module.exports = __webpack_public_path__ + "static/media/thumnail.fdd7fd20.svg";